import { useEffect, useState } from "react";
import { environment } from "../environment";
import { DateUtil } from "../utils/date.util";
import { useAxios } from "./useAxios";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

export const useReporting = () => {
  const { axiosInstance } = useAxios();
  const {t} = useTranslation();

  const [exportFlag, setExportFlag] = useState(false);

  const [loadingFlag, setLoadingFlag] = useState(false);
  const [accessToken, setAccessToken] = useState("");
  const [atributeObject, setAttributeObject] = useState({
    report: "",
    type: "",
    startDate: "",
    endDate: "",
  });

  const ShowToastMessage = (text) =>
    toast(<p className="mx-2 tx-16 d-flex align-items-center mb-0 ">{text}</p>, {
      position: toast.POSITION.TOP_RIGHT,
      hideProgressBar: true,
    });

  const accesToken = () => {
    const url = `${process.env.REACT_APP_PGW_URL}${environment.accessToken}`;

    const header = { "Content-Type": "application/x-www-form-urlencoded" };

    const bodyData = new URLSearchParams({
      grant_type: "password",
      username: `${process.env.REACT_APP_PGW_USER}`,
      password: `${process.env.REACT_APP_PGW_PASS}`,
    });
    axiosInstance?.current
      .post(url, bodyData, header)
      .then((response) => {
        setAccessToken(response?.data?.access_token);
      })
      .catch((err) => {
        if(err?.response?.status === 500){
          ShowToastMessage(t("toastr.reports.token")+t("toastr.general.failed.error500"));
        }else if(err?.response?.status === 401){
          ShowToastMessage(t("toastr.reports.token")+t("toastr.general.failed.error401"));
        }else if(err?.response?.status === 404){
          ShowToastMessage(t("toastr.reports.token")+t("toastr.general.failed.error404"));
        }else if(err?.response?.status === 204){
          ShowToastMessage(t("toastr.reports.token")+t("toastr.general.failed.error204"));
        }
        setExportFlag(false)
        console.log("Error response => ", err);
      });
  };

  const header = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
      //Authorization: `Bearer HIDDEN`,
    },
  };

  const getAccesTokenOrDownload = (selectedReport, selectedType, startDate, endDate) => {
    setExportFlag(true)
    if (accessToken) {
      postDownloadFile(selectedReport, selectedType, startDate, endDate);
    } else {
      setAttributeObject({
        ...atributeObject,
        report: selectedReport,
        type: selectedType,
        startDate: startDate,
        endDate: endDate,
      });
      accesToken();
    }
  };

  useEffect(() => {
    if (accessToken) {
      getAccesTokenOrDownload(atributeObject?.report, atributeObject?.type, atributeObject?.startDate, atributeObject?.endDate);
    }
  }, [accessToken]);

  const getPGWReport = () => {
    setLoadingFlag(true);
    const url = `${environment.pgwReporter}${environment.getReportDefinitionList}`;

    axiosInstance?.current
      .get(url, header)
      .then((response) => {
        setLoadingFlag(false);
        console.log("PGW REPORTER RESPONSE =>", response.data);
      })
      .catch((error) => {
        setLoadingFlag(false);
        console.log("PGW GET REPORTER ERROR =>", { error });
      });
  };

  const postDownloadFile = (report, types, startDate, endDate) => {
    const start = DateUtil.formatDate(startDate);
    const end = DateUtil.formatDate(endDate);

    const startFormated = start.slice(0, 19);
    const endFormated = end.slice(0, 19);

    const url = `${process.env.REACT_APP_PGW_URL}${environment.getReport}`;

    const config =
      types === "EXCEL"
        ? {
            //https://syntaxfix.com/question/3863/how-to-save-xlsx-data-to-file-as-a-blob -> third response was the solution (adding the responseType: blob)
            headers: {
              "Content-Type": "application/json",
              //Authorization: `Bearer HIDDEN`,
              Authorization: `Bearer ${accessToken}`,
            },
            responseType: "blob",
          }
        : {
            headers: {
              "Content-Type": "application/json",
              //Authorization: `Bearer HIDDEN`,
              Authorization: `Bearer ${accessToken}`,
            },
          };

    const bodyPayload = report.value;
    bodyPayload.Parameters[0].ValueDate = startFormated;
    bodyPayload.Parameters[1].ValueDate = endFormated;

    if (types === "EXCEL") {
      bodyPayload.ReportFormat = 1;
    } else {
      bodyPayload.ReportFormat = 0;
    }

    axiosInstance?.current
      ?.post(url, bodyPayload, config)
      .then((response) => {
        setExportFlag(false)
        const blob =
          types === "EXCEL"
            ? new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
            : new Blob([response.data], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", report.label);
        link.click();
      })
      .catch((err) => {
        setExportFlag(false)
        if(err?.response?.status === 500){
          ShowToastMessage(t("toastr.reports.reportDownload")+t("toastr.general.failed.error500"));
        }else if(err?.response?.status === 401){
          ShowToastMessage(t("toastr.reports.reportDownload")+t("toastr.general.failed.error401"));
        }else if(err?.response?.status === 404){
          ShowToastMessage(t("toastr.reports.reportDownload")+t("toastr.general.failed.error404"));
        }else if(err?.response?.status === 204){
          ShowToastMessage(t("toastr.reports.reportDownload")+t("toastr.general.failed.error204"));
        }
        console.log("PGW POST REPORTER ERROR =>", { err, url, bodyPayload, header });

      });
  };

  return { loadingFlag, getAccesTokenOrDownload, exportFlag };
};
